import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpClaimListing } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { QUEUE_COUNTS_QUERY_KEY } from './use-get-queue-counts'
import { VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY } from './use-get-visual-vetting-listing-details'
import { VISUAL_VETTING_LISTINGS_QUERY_KEY } from './use-get-visual-vetting-listings'

export const useClaimListing = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (listingIds: string[]) => httpClaimListing(listingIds),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_COUNTS_QUERY_KEY]
			})
		}
	})
}
